import { FormikProps } from "formik";
import { makeStyles, mergeClasses } from "@fluentui/react-components";
import { NoteRegular } from "@fluentui/react-icons";
import { BrandCard, CustomCardHeader, Column } from "../../../common";
import { CaseNoteForm } from "../../../controls/CaseNoteForm";
import { NoteControl } from "../../../controls/NoteControl";
import { Case, Note } from "../../../../data/types";

export const useStyles = makeStyles({
    root: {
    },
    noteColumn: {
        maxHeight: '15rem',
        overflowY: 'auto'
    }
});
export type CaseNotesCardProps  ={
    className?: string;
    caseForm?: FormikProps<Case>;    
    notePanelClassName?: string;
}
export const CaseNotesCard = (props: CaseNotesCardProps) => {

    const { className, caseForm, notePanelClassName } = props;

    const caseObj = caseForm?.values as Case;

    //Styles
    const styles = useStyles();
    const cardClasses = mergeClasses(
        styles.root,
        className
    );

    //Logic
    const addCaseNote = async (caseNote: Note) => {
        if (caseNote.text) {
            caseForm?.setFieldValue('caseNotes', [...(caseForm.values.caseNotes || []), caseNote]);
        }
    }

    return (
        <BrandCard className={cardClasses}>
            <CustomCardHeader title='Notes' icon={<NoteRegular />} />
            <CaseNoteForm caseId={caseObj?.caseId} submitNote={addCaseNote} required={false} />
            <Column className={notePanelClassName} padding='pt-3 pb-2'>
                <div className={styles.noteColumn}>
                    {caseForm?.values.caseNotes?.sort((a: Note, b: Note) => (b.lifecycle?.createdOn?.valueOf() || 0) - (a.lifecycle?.createdOn?.valueOf() || 0)).map((note: Note, index: number) => (
                        <NoteControl
                            key={index}
                            note={note}
                        />
                    ))}
                </div>
            </Column>
        </BrandCard>
    );
}